<script>
export default {
    props: {
     title: {
      type: String,
      default: ''
    },
    firstName: {
      type: String,
      default: ''
    },
    secondName: {
      type: String,
      default: ''
    },

    categories: {
      type: Array,
      default: () => []
    },

    data: {
      type: Array,
      default: () => []
    },

    dataTotal: {
      type: Array,
      default: () => []
    },

  },

  computed:{
    ifDefaultTheme(){
      return  process.env.VUE_APP_THEME == 0
    },


        
  chartOptions() {
    if (this.ifDefaultTheme) {
      return {

            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '45%',
                //endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: this.categories,
            },
            yaxis: {
              title: {
                text: 'CA (TND)'
              },
              labels: {
              formatter: function (value) {
                  return Math.round(value); 
              }
          }
        
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                    return "TND " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
              }
            },
            title: {
          text: this.title,
          align: 'left',
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: true,
          style: {
            fontSize: '16px',
            color: '#263238'
          },
        },
      };
    } else {
      return {
            chart: {
              type: 'line',
              height: 350
            },
            dataLabels: {
              enabled: true
            },
            stroke: {
              curve: 'smooth',
              show: true,
              dashArray: [8, 0],
              width: 4,
              colors: ['#27AE60', '#4f81bd'],
            },
            xaxis: {
              categories: this.categories,
            },
            yaxis: {
              title: {
                text: 'CA (TND)'
              },
              labels: {
              formatter: function (value) {
                  return Math.round(value); 
              }
          }
        
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                    return "TND " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
              }
            },
           colors: ['#27AE60', '#4f81bd'],

            title: {

          text: this.title,
          align: 'left',
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: '16px',
            color: '#263238'
          },
        },
      };
    }
  },

  },

  data() {
    return {
      
    
        series: [{
            name: this.firstName,
            data: this.data,
          }, {
            name: this.secondName,
            data: this.dataTotal, 
          }
        ],
 
        
    };
  },
};
</script>

<template>
<div id="chart">
        <apexchart :type="ifDefaultTheme? 'bar' : 'line'" height="350" :options="chartOptions" :series="series" />
      </div>
</template>
